/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Constants } from 'app/shared/models/constants.model';

@Component({
  host: { class: 'system-notification' },
  selector: '[systemNotification]',
  templateUrl: './system-notification.component.html',
  styleUrls: ['./system-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemNotificationComponent implements OnInit {
  @Input() message: string;
  @Input() messageType: string;
  @Output() close: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.info') messageTypeInfo = false;
  @HostBinding('class.warning') messageTypeWarning = false;
  @HostBinding('class.danger') messageTypeDanger = false;

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    this.messageTypeInfo = this.messageType === Constants.SYSTEM_NOTIFICATION_TYPES.INFO;
    this.messageTypeWarning = this.messageType === Constants.SYSTEM_NOTIFICATION_TYPES.WARNING;
    this.messageTypeDanger = this.messageType === Constants.SYSTEM_NOTIFICATION_TYPES.DANGER;
  }

  closeNotification($event) {
    $event.preventDefault();
    this.close.emit();
  }
}
